export default {
  messageSendFailure: 'Failed to send. Press to retry.',
  messageBot: 'Bot',
};
